/* post-t7-1, Bloque F1 (#580): LA PAGINA CREA EL INVITADO DE "START FREE".

   ARCHIVO EN ASCII A PROPOSITO. Lo pinta el guardia de sesion cuando la ruta es `/dashboard?start=1`, no hay sesion
   y no es la app. Mientras tanto se ve la pantalla de carga de siempre (el logo del arranque), nunca la de iniciar
   sesion ni la portada. Al nacer el invitado, el guardia ve la sesion y limpia la barra (sin entrada en el
   historial). Si falla (el freno de invitados por IP o la red), la persona termina en la portada con el aviso que ya
   existia para eso.

   Remate de post-t7-2c (R2 punto 8, decidido el 15-oct): "EMPEZAR GRATIS" EN LA WEB SIN LOGO. Mientras crea el
   invitado, en la web pinta `esqueleto` (el esqueleto del Panel, el MISMO que `ProtectedRoute` pinta para
   `/dashboard` mientras la sesion resuelve: `esqueletoDelArranque` de App.js, que el guardia le pasa por prop para no
   importar App.js, que importa a los guardias). En la app, o sin esqueleto, el logo de siempre (`BootSplash`). */
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';
import { IS_APP_BUILD } from '../lib/buildTarget';
import { arrancarInvitado, atribucionDelClic } from '../lib/arranqueInvitado';
import BootSplash from './BootSplash';

export default function ArranqueDeInvitado({ search, esqueleto }) {
  const { loginAsGuest } = useAuth();
  const { t } = useTranslation();
  const [fallo, setFallo] = useState(false);

  useEffect(() => {
    let vivo = true;
    let referrer = '';
    try { referrer = document.referrer || ''; } catch { referrer = ''; }
    arrancarInvitado(loginAsGuest, atribucionDelClic(search, referrer)).catch((err) => {
      toast.error(err?.response?.status === 429 ? t('common:toasts.guest_rate_limit') : t('common:toasts.guest_session_failed'),
        { id: 'arranque-invitado' });
      if (vivo) setFallo(true);
    });
    return () => { vivo = false; };
    // una sola vez por montaje: la promesa en vuelo la comparte un segundo montaje
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (fallo) return <Navigate to="/" replace />;
  if (!IS_APP_BUILD && esqueleto) return esqueleto;
  return <BootSplash active />;
}
